import { userUTCDateFormat } from '@cumu/shared';

export function linkRenderer(
  href: string | null | undefined,
  value: unknown,
  fallbackText = ''
) {
  if (!href) {
    const span = document.createElement('span');
    span.textContent =
      value === null || value === undefined ? '' : String(value);
    return span;
  }
  const text =
    value === null || value === undefined ? fallbackText : `${value}`;
  const link = document.createElement('a');
  link.href = href;
  link.textContent = text;
  return link;
}

export function renderCodeDescription(
  code: string | null | undefined,
  description: string | null | undefined
) {
  if (!code) {
    return '';
  }

  const container = document.createElement('span');
  const codeElement = document.createElement('span');
  codeElement.className = 'text-bold';
  codeElement.textContent = code;
  container.append(codeElement);

  if (description) {
    const descriptionElement = document.createElement('span');
    descriptionElement.className = 'd-block color-fg-muted';
    descriptionElement.textContent = description;
    container.append(descriptionElement);
  }

  return container;
}

export function codeDescription(
  code: string | null | undefined,
  description: string | null | undefined
) {
  return [code, description].filter(Boolean).join(' ');
}

export function dateRange(
  start: string | null | undefined,
  end: string | null | undefined
) {
  if (!start || !end) {
    return '';
  }
  if (start === end) {
    return formatUTCDate(start);
  }
  return `${formatUTCDate(start)} - ${formatUTCDate(end)}`;
}

export function formatUTCDate(value: unknown) {
  if (!value || typeof value !== 'string') {
    return '';
  }
  return userUTCDateFormat.format(new Date(`${value}T00:00:00Z`));
}
